<template>
	<div>
		<label class="mb-0">
			<input type="checkbox" class="input-checkbox input-checkbox-large" :checked="checked" @change="onChange">
			<span></span>
			<span class="input-checkbox-text">{{ label }}</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'InputCheckbox',
	props: {
		value: {},
		checked: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
	},
	methods: {
		onChange(event) {
			const isChecked = event.target.checked;
			this.$emit('update:checked', isChecked);
			// Add a action emits because old version code is deprecated in vue 2 and get warn or error in eslint !!
			this.$emit('on-change', isChecked);
		},
	},
};
</script>
